module.exports = __webpack_public_path__ + "img/courses.ddb09f7a.png";